import { ENV } from '../config/env';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export class HttpError extends Error {
  status: number;
  payload: unknown;

  constructor(status: number, payload: unknown) {
    const message =
      typeof payload === 'string'
        ? payload
        : typeof payload === 'object' && payload !== null && 'message' in payload
          ? Array.isArray((payload as any).message)
            ? (payload as any).message.join(', ')
            : String((payload as any).message)
          : 'Request failed';
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

interface RequestOptions {
  method?: HttpMethod;
  body?: unknown;
  headers?: Record<string, string>;
  auth?: boolean;
}

function getToken() {
  return localStorage.getItem('auth_token');
}

export async function http<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
  const url = `${ENV.API_URL}${endpoint}`;
  const auth = options.auth !== false;
  const token = auth ? getToken() : null;

  const res = await fetch(url, {
    method: options.method || 'GET',
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {})
    },
    body: options.body ? JSON.stringify(options.body) : undefined
  });

  const contentType = res.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const payload = isJson ? await res.json().catch(() => null) : await res.text().catch(() => '');

  if (!res.ok) {
    if (res.status === 401 && auth) {
      const detail =
        typeof payload === 'object' && payload !== null
          ? payload
          : { message: 'Sesión inválida o expirada.' };
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('auth:unauthorized', { detail }));
      }
    }
    throw new HttpError(res.status, payload);
  }

  return payload as T;
}
